import { DEFAULT_LANGUAGE_CODE, normalizeUiLanguageCode } from "./languages.js";

export const FAQ_PAGE_PATH = "/faq";

export function buildFaqPath(locale = DEFAULT_LANGUAGE_CODE) {
  const normalizedLocale = normalizeUiLanguageCode(locale);
  return normalizedLocale === DEFAULT_LANGUAGE_CODE
    ? FAQ_PAGE_PATH
    : `/l/${encodeURIComponent(normalizedLocale)}${FAQ_PAGE_PATH}`;
}

export function buildFaqHomePath(locale = DEFAULT_LANGUAGE_CODE) {
  const normalizedLocale = normalizeUiLanguageCode(locale);
  return normalizedLocale === DEFAULT_LANGUAGE_CODE
    ? "/"
    : `/l/${encodeURIComponent(normalizedLocale)}`;
}
